var _path;
import * as React from "react";
function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 5.491c0-1.487-1.916-2.048-2.76-.815C11 15.991 22 16.5 22 22a4 4 0 01-4.053 4C15.749 25.97 14 24.138 14 21.94v-5.344c0-1.356-1.654-2.014-2.59-1.031C9.739 17.323 8 20.333 8 24c0 6.617 5.383 12 12 12s12-5.383 12-12c0-10.643-10.5-12.063-10.5-18.509z"
  })));
}
export default SvgFire;